import React from "react";
import "../App.css";

import Header from "./header";
import Logo from "./swiper/swiper";
import Random from "./random";
import FeaturedProducts from "./featuredProducts";
import Span from "../span";
import Footer1 from "./footer1/footer1";
import Footer2 from "./footer2/footer2";

function Home() {

  return (
    <div>
      <Header />
      <Logo />
      <Random />
      <FeaturedProducts/>
      <Span />
      <Footer1 />
      <Footer2 />
    </div>
  );
}

export default Home;
